const ParamCardList = {
    projectperiod: {
        initialTerm: '2019',
        operate: '20',
        build: '2',
    },
    capitalsource: {
        capitalRatio: '50',
        borrowingRate: '4.9',
        loanTerm: '15',
        periodGrace: '2',
        predeterminedNumber: '4',
        repayment: '等额本金',
    },
    assetformation: {
        fixedAssetsRatio: '95',
        residualRrate: '5',
        depreciationPeriod: '15',
        reimbursementPeriod: '5',
    },
    productioncost: {
        capacity: '4',
        annualSalary: '8',
        welfareFactor: '0',
        insuranceRate: '0.25',
        materialsExpenses: '5.0',
        otherExpenses: '1.0',
    },
    workingcapitalandfinancialexpenses: {
        workingCapitalLoanRatio: '70',
        interestRateAndWorkingCapital: '4',
        annualAPCirculationTimes: '12',
        annualStockCirculationTimes: '12',
        annualCashCirculationTimes: '12',
        annualARCirculationTimes: '12',
    },
    projectcalculation: {
        electricityVATRate: '18',
        steamSaleVATRate: '12',
        hotColdVATRate: '12',
        fuelBoughtVATRate: '10',
        materialBoughtVATRate: '17',
        legalAccumulationFundRate: '10',
        aleatoricAccumulationFundRate: '0',
        cityMaintenanceConstructionTaxTate: '5',
        educationFeePlus: '5',
        localEducationPlus: '2',
        corporateIncomeTaxRate: '25',
        basicDiscountRate: '8',
    },
};

export default ParamCardList;
